import type { ModalConfig } from "./types";

export const timeEntryModalsModalUrlConfig = {
  // Time Entry Modals
  "time_entries-detail": {
    modalId: "time_entries-detail",
    entityName: "time_entries",
    singularParam: "timeEntryId",
    pluralParam: "timeEntriesId",
    displayName: "Time Entry",
  },
  "edit-time_entries": {
    modalId: "edit-time_entries",
    entityName: "time_entries",
    singularParam: "timeEntryId",
    pluralParam: "timeEntriesId",
    displayName: "Time Entry",
  },
} as const satisfies Record<string, ModalConfig>;
